import Model from '@/store/model';
import Pricing from './pricing';
import CorrectAnswerPricing from './correct_answer_pricing';
import TestGrammarPricing from './test_grammar_pricing';
import User from '../user/user';
import SkillRewards from './skill_rewards';
import GrammarReferences from './grammar_references';
import Expressions from './expressions';
import Classmates from './classmates';

class LessonResponse extends Model {
  map(json) {
    super.map(json);

    if (json.pricing !== undefined && json.pricing !== null) {
      this.pricing = new Pricing();
      this.pricing.map(json.pricing);
    }

    if (json.correct_answer_pricing !== undefined && json.correct_answer_pricing !== null) {
      this.correctAnswerPricing = new CorrectAnswerPricing();
      this.correctAnswerPricing.map(json.correct_answer_pricing);
    }

    if (json.test_grammar_pricing !== undefined && json.test_grammar_pricing !== null) {
      this.testGrammarPricing = new TestGrammarPricing();
      this.testGrammarPricing.map(json.test_grammar_pricing);
    }

    if (json.skill_rewards !== undefined && json.skill_rewards !== null) {
      this.skillRewards = new SkillRewards();
      this.skillRewards.map(json.skill_rewards);
    }

    if (json.friends !== undefined && json.friends !== null) {
      this.mapArray('friends', json.friends, User);
    }

    if (json.expressions !== undefined && json.expressions !== null) {
      this.mapArray('expressions', json.expressions, Expressions);
    }

    if (json.skill_rewards !== undefined && json.skill_rewards !== null) {
      this.mapArray('skillRewards', json.skill_rewards, SkillRewards);
    }
    if (json.grammar_references !== undefined && json.grammar_references !== null) {
      this.mapArray('grammarReferences', json.grammar_references, GrammarReferences);
    }
    if (json.classmates !== undefined && json.classmates !== null) {
      this.mapArray('classmates', json.classmates, Classmates);
    }
  }
}
export default LessonResponse;
